import { getContractAddress } from 'utilities';

export const BRN_VAULT_PROXY_CONTRACT_ADDRESS = getContractAddress('brnVaultProxy');

export const BAI_TOKEN_ID = 'bai';
export const BAI_VAULT_ADDRESS = getContractAddress('baiVault');
